// This file is auto-generated. Do not modify this file manually.

// vite-env.d.ts or env.d.ts (at your app root)
/// <reference types="vite-plugin-svgr/client" />

import IQ from '../../Assets/images/icons/IQ.svg?react';
import academyLg from '../../Assets/images/icons/academy_lg.svg?react';
import accountRg from '../../Assets/images/icons/account_rg.svg?react';
import amex from '../../Assets/images/icons/amex.svg?react';
import applepay from '../../Assets/images/icons/applepay.svg?react';
import arrowDownRg from '../../Assets/images/icons/arrow_down_rg.svg?react';
import arrowLeftRg from '../../Assets/images/icons/arrow_left_rg.svg?react';
import arrowRightRg from '../../Assets/images/icons/arrow_right_rg.svg?react';
import arrowUpRg from '../../Assets/images/icons/arrow_up_rg.svg?react';
import awardLg from '../../Assets/images/icons/award_lg.svg?react';
import basketFilledRg from '../../Assets/images/icons/basket_filled_rg.svg?react';
import basketRg from '../../Assets/images/icons/basket_rg.svg?react';
import bellSm from '../../Assets/images/icons/bell_sm.svg?react';
import binSm from '../../Assets/images/icons/bin_sm.svg?react';
import bulkBuyLg from '../../Assets/images/icons/bulk_buy_lg.svg?react';
import bulkBuyNoCircle from '../../Assets/images/icons/bulk_buy_no_circle.svg?react';
import callRg from '../../Assets/images/icons/call_rg.svg?react';
import checklistOrder from '../../Assets/images/icons/checklistOrder.svg?react';
import checklistLg from '../../Assets/images/icons/checklist_lg.svg?react';
import clinicOrder from '../../Assets/images/icons/clinic_order.svg?react';
import closeRg from '../../Assets/images/icons/close_rg.svg?react';
import closeSm from '../../Assets/images/icons/close_sm.svg?react';
import collapseSm from '../../Assets/images/icons/collapse_sm.svg?react';
import companyLg from '../../Assets/images/icons/company_lg.svg?react';
import continueLg from '../../Assets/images/icons/continue_lg.svg?react';
import crossXs from '../../Assets/images/icons/cross_xs.svg?react';
import dateSm from '../../Assets/images/icons/date_sm.svg?react';
import deleteCellAction from '../../Assets/images/icons/delete_cell_action.svg?react';
import deliveredLg from '../../Assets/images/icons/delivered_lg.svg?react';
import devicesLg from '../../Assets/images/icons/devices_lg.svg?react';
import directToPatientLg from '../../Assets/images/icons/direct_to_patient_lg.svg?react';
import docUploadLg from '../../Assets/images/icons/doc_upload_lg.svg?react';
import dosageInstructionsSm from '../../Assets/images/icons/dosage_instructions_sm.svg?react';
import downloadSm from '../../Assets/images/icons/download_sm.svg?react';
import dropdownSm from '../../Assets/images/icons/dropdown_sm.svg?react';
import dtpOrder from '../../Assets/images/icons/dtp_order.svg?react';
import duplicateCellAction from '../../Assets/images/icons/duplicate_cell_action.svg?react';
import editCellActon from '../../Assets/images/icons/edit_cell_acton.svg?react';
import editRg from '../../Assets/images/icons/edit_rg.svg?react';
import editSm from '../../Assets/images/icons/edit_sm.svg?react';
import editUserLg from '../../Assets/images/icons/edit_user_lg.svg?react';
import editUserSm from '../../Assets/images/icons/edit_user_sm.svg?react';
import emailLg from '../../Assets/images/icons/email_lg.svg?react';
import errorSm from '../../Assets/images/icons/error_sm.svg?react';
import eventsLg from '../../Assets/images/icons/events_lg.svg?react';
import facebookSocial from '../../Assets/images/icons/facebook_social.svg?react';
import filterAndSortSm from '../../Assets/images/icons/filter_and_sort_sm.svg?react';
import flagIRE from '../../Assets/images/icons/flag_IRE.svg?react';
import flagUK from '../../Assets/images/icons/flag_UK.svg?react';
import floatingMenuTopper from '../../Assets/images/icons/floating_menu_topper.svg?react';
import fourOhFourLg from '../../Assets/images/icons/fourOhFour_lg.svg?react';
import googlePay from '../../Assets/images/icons/googlePay.svg?react';
import hideSm from '../../Assets/images/icons/hide_sm.svg?react';
import hxBasicWhiteLogo from '../../Assets/images/icons/hx_basic_white_logo.svg?react';
import icnMiniWarningBlk from '../../Assets/images/icons/icn_mini_warning_blk.svg?react';
import iconPlayMed from '../../Assets/images/icons/icon_play_med.svg?react';
import infoSm from '../../Assets/images/icons/info_sm.svg?react';
import instagramSocial from '../../Assets/images/icons/instagram_social.svg?react';
import invoicesLg from '../../Assets/images/icons/invoices_lg.svg?react';
import issueSm from '../../Assets/images/icons/issue_sm.svg?react';
import linkedinSocial from '../../Assets/images/icons/linkedin_social.svg?react';
import locationLg from '../../Assets/images/icons/location_lg.svg?react';
import lockRg from '../../Assets/images/icons/lock_rg.svg?react';
import logoHealthxchangeSmall from '../../Assets/images/icons/logo_healthxchange_small.svg?react';
import mailSm from '../../Assets/images/icons/mail_sm.svg?react';
import maintenanceLg from '../../Assets/images/icons/maintenance_lg.svg?react';
import mastercard from '../../Assets/images/icons/mastercard.svg?react';
import menuRg from '../../Assets/images/icons/menu_rg.svg?react';
import messagesLg from '../../Assets/images/icons/messages_lg.svg?react';
import minusSm from '../../Assets/images/icons/minus_sm.svg?react';
import minusXs from '../../Assets/images/icons/minus_xs.svg?react';
import moreRg from '../../Assets/images/icons/more_rg.svg?react';
import moveToPatientSm from '../../Assets/images/icons/move_to_patient_sm.svg?react';
import noResultsLg from '../../Assets/images/icons/no_results_lg.svg?react';
import notesLg from '../../Assets/images/icons/notes_lg.svg?react';
import offerLg from '../../Assets/images/icons/offer_lg.svg?react';
import offerOrder from '../../Assets/images/icons/offer_order.svg?react';
import orderBuilderRg from '../../Assets/images/icons/order_builder_rg.svg?react';
import orderConfirmedLg from '../../Assets/images/icons/order_confirmed_lg.svg?react';
import orderLg from '../../Assets/images/icons/order_lg.svg?react';
import patientsLg from '../../Assets/images/icons/patients_lg.svg?react';
import paymentMastercard from '../../Assets/images/icons/payment_mastercard.svg?react';
import paymentOptionsCellAction from '../../Assets/images/icons/payment_options_cell_action.svg?react';
import phoneLg from '../../Assets/images/icons/phone_lg.svg?react';
import phoneSm from '../../Assets/images/icons/phone_sm.svg?react';
import photoIdLg from '../../Assets/images/icons/photo_id_lg.svg?react';
import plusRg from '../../Assets/images/icons/plus_rg.svg?react';
import plusSm from '../../Assets/images/icons/plus_sm.svg?react';
import plusXs from '../../Assets/images/icons/plus_xs.svg?react';
import problemSm from '../../Assets/images/icons/problem_sm.svg?react';
import productsLg from '../../Assets/images/icons/products_lg.svg?react';
import purchaseApprove from '../../Assets/images/icons/purchaseApprove.svg?react';
import refreshRg from '../../Assets/images/icons/refresh_rg.svg?react';
import rejectCellAction from '../../Assets/images/icons/reject_cell_action.svg?react';
import resourcesLg from '../../Assets/images/icons/resources_lg.svg?react';
import reviewLg from '../../Assets/images/icons/review_lg.svg?react';
import rxLg from '../../Assets/images/icons/rx_lg.svg?react';
import rxOrder from '../../Assets/images/icons/rx_order.svg?react';
import savedLg from '../../Assets/images/icons/saved_lg.svg?react';
import searchRg from '../../Assets/images/icons/search_rg.svg?react';
import searchSm from '../../Assets/images/icons/search_sm.svg?react';
import shippingLg from '../../Assets/images/icons/shipping_lg.svg?react';
import showSm from '../../Assets/images/icons/show_sm.svg?react';
import signCellAction from '../../Assets/images/icons/sign_cell_action.svg?react';
import signatureLg from '../../Assets/images/icons/signature_lg.svg?react';
import signedOrder from '../../Assets/images/icons/signed_order.svg?react';
import sortRg from '../../Assets/images/icons/sort_rg.svg?react';
import staffUsersLg from '../../Assets/images/icons/staff_users_lg.svg?react';
import stockLg from '../../Assets/images/icons/stock_lg.svg?react';
import stockOrder from '../../Assets/images/icons/stock_order.svg?react';
import submitMiniButton from '../../Assets/images/icons/submit_mini_button.svg?react';
import successSm from '../../Assets/images/icons/success_sm.svg?react';
import supportChatLg from '../../Assets/images/icons/support_chat_lg.svg?react';
import supportLg from '../../Assets/images/icons/support_lg.svg?react';
import supportOrder from '../../Assets/images/icons/support_order.svg?react';
import switchRg from '../../Assets/images/icons/switch_rg.svg?react';
import techLg from '../../Assets/images/icons/tech_lg.svg?react';
import tickXs from '../../Assets/images/icons/tick_xs.svg?react';
import tiktokSocial from '../../Assets/images/icons/tiktok_social.svg?react';
import tncsLg from '../../Assets/images/icons/tncs_lg.svg?react';
import trackingCellAction from '../../Assets/images/icons/tracking_cell_action.svg?react';
import unlockCellAction from '../../Assets/images/icons/unlock_cell_action.svg?react';
import upDownArrowSm from '../../Assets/images/icons/up_down_arrow_sm.svg?react';
import userLg from '../../Assets/images/icons/user_lg.svg?react';
import userSuccessLg from '../../Assets/images/icons/user_success_lg.svg?react';
import videoPlayLg from '../../Assets/images/icons/video_play_lg.svg?react';
import videoPlaySm from '../../Assets/images/icons/video_play_sm.svg?react';
import viewCellAction from '../../Assets/images/icons/view_cell_action.svg?react';
import visa from '../../Assets/images/icons/visa.svg?react';
import waitLg from '../../Assets/images/icons/wait_lg.svg?react';
import warningLg from '../../Assets/images/icons/warning_lg.svg?react';
import warningNoCircle from '../../Assets/images/icons/warning_no_circle.svg?react';
import warningSm from '../../Assets/images/icons/warning_sm.svg?react';
import warningXs from '../../Assets/images/icons/warning_xs.svg?react';
import xSocial from '../../Assets/images/icons/x_social.svg?react';
import youtubeSocial from '../../Assets/images/icons/youtube_social.svg?react';

export const icons = {
  IQ,
  academyLg,
  accountRg,
  amex,
  applepay,
  arrowDownRg,
  arrowLeftRg,
  arrowRightRg,
  arrowUpRg,
  awardLg,
  basketFilledRg,
  basketRg,
  bellSm,
  binSm,
  bulkBuyLg,
  bulkBuyNoCircle,
  callRg,
  checklistOrder,
  checklistLg,
  clinicOrder,
  closeRg,
  closeSm,
  collapseSm,
  companyLg,
  continueLg,
  crossXs,
  dateSm,
  deleteCellAction,
  deliveredLg,
  devicesLg,
  directToPatientLg,
  docUploadLg,
  dosageInstructionsSm,
  downloadSm,
  dropdownSm,
  dtpOrder,
  duplicateCellAction,
  editCellActon,
  editRg,
  editSm,
  editUserLg,
  editUserSm,
  emailLg,
  errorSm,
  eventsLg,
  facebookSocial,
  filterAndSortSm,
  flagIRE,
  flagUK,
  floatingMenuTopper,
  fourOhFourLg,
  googlePay,
  hideSm,
  hxBasicWhiteLogo,
  icnMiniWarningBlk,
  iconPlayMed,
  infoSm,
  instagramSocial,
  invoicesLg,
  issueSm,
  linkedinSocial,
  locationLg,
  lockRg,
  logoHealthxchangeSmall,
  mailSm,
  maintenanceLg,
  mastercard,
  menuRg,
  messagesLg,
  minusSm,
  minusXs,
  moreRg,
  moveToPatientSm,
  noResultsLg,
  notesLg,
  offerLg,
  offerOrder,
  orderBuilderRg,
  orderConfirmedLg,
  orderLg,
  patientsLg,
  paymentMastercard,
  paymentOptionsCellAction,
  phoneLg,
  phoneSm,
  photoIdLg,
  plusRg,
  plusSm,
  plusXs,
  problemSm,
  productsLg,
  purchaseApprove,
  refreshRg,
  rejectCellAction,
  resourcesLg,
  reviewLg,
  rxLg,
  rxOrder,
  savedLg,
  searchRg,
  searchSm,
  shippingLg,
  showSm,
  signCellAction,
  signatureLg,
  signedOrder,
  sortRg,
  staffUsersLg,
  stockLg,
  stockOrder,
  submitMiniButton,
  successSm,
  supportChatLg,
  supportLg,
  supportOrder,
  switchRg,
  techLg,
  tickXs,
  tiktokSocial,
  tncsLg,
  trackingCellAction,
  unlockCellAction,
  upDownArrowSm,
  userLg,
  userSuccessLg,
  videoPlayLg,
  videoPlaySm,
  viewCellAction,
  visa,
  waitLg,
  warningLg,
  warningNoCircle,
  warningSm,
  warningXs,
  xSocial,
  youtubeSocial,
};
